import { render, staticRenderFns } from "./OpenExternalIcon.vue?vue&type=template&id=3bdf453e&scoped=true"
import script from "./OpenExternalIcon.vue?vue&type=script&lang=js"
export * from "./OpenExternalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf453e",
  null
  
)

export default component.exports